<script>
  import ActionDialog from "../components/ActionDialog.svelte";
  import HostDialog from "../components/HostDialog.svelte";
  import UserBar from "../components/UserBar.svelte"

  import firebase from "../lib/firebase";
  import {isWIRusUser} from "../lib/wirus-integration"
  import actions from "../lib/actions";

  let user = firebase.auth().currentUser;

  $: host = localStorage.getItem("host");

  const showDialogForAction = action => {
    let dialog = new ActionDialog({
      target: document.getElementById("dialog-container"),
      props: { action, host }
    });
    dialog.$on("destroy", () => {
      dialog.$destroy();
    });
  };
</script>

<style>
  .platform-wrapper {
    display: flex;
    flex-flow: column;
    padding: 50px;
  }
  
  .actions-list {
    padding: 30px 0;
    display: flex;
    flex-flow: column;
    min-width: 50vw;
  }
  .action {
    border-radius: 20px;
    box-shadow: 4px 4px 10px -2px rgba(0, 0, 0, 0.2);
    background: white;
    padding: 20px 40px;
    margin-bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: background-color 0.3s;
  }
  .action:hover {
    background: #eee;
  }
  .action-content {
    display: flex;
    flex-flow: column;
  }
  .action-title {
    font-size: 18px;
    font-weight: 600;
  }
  .action-desc {
    font-size: 14px;
    max-width: 100%;
  }
  .action-points-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
    font-size: 14px;
    font-weight: 600;
    z-index: 1;
    position: relative;
  }

  .action-points-wrapper::before {
    content: "";
    display: block;
    position: absolute;
    border-radius: 100%;
    z-index: -1;
    width: 130%;
    height: 130%;
    background: #ff8811;
    opacity: 0.2;
  }
  .action-points {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    background: #ff8811;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .info {
    max-width: 700px;
  }

</style>

<div class="main">
  <div class="platform-wrapper">
    <UserBar bind:host={host}></UserBar>

    {#if host}

    {#if !isWIRusUser()}
  <div class="info">
    Dein Plattform-Account <em>{user.email}</em> ist nicht mit WIRus gekoppelt. Du wirst in deiner App keine Punkte für Aktionen auf dieser Plattform sehen.
  </div>
{:else}
    <div class="info">
      Plattformen können verschiedene Arten von Aktionen und Hilfeleistungen anbieten. <br/>
      Daher gibt es auch unterschiedliche Wege, auf denen du Punkte für deine Aktionen bekommst.<br/>
      Manche Aktionen geben direkt Punkte, manche werden erst nach erfolgreichen Abschluss von der Plattform bestätigt.<br/><br/>
      Einige Plattformen agieren auch rein als Vermittlung zwischen Helfer und Hilfesuchenden <em>(hier: Host einer Aktion)</em> und verfolgen daher nicht den Ausgang
      einer Aktion auf der Plattform. In diesem Fall muss der Hilfesuchende die Punkte per Email bestätigen. <br/>
      <b>Probiere es einfach aus.</b>
      
    </div>
    {/if}
    <div class="actions-list">
      {#each actions as action}
        <div class="action" on:click={() => showDialogForAction(action)}>
          <div class="action-content">
            <div class="action-title">{action.title}</div>
            <div class="action-desc">{action.description}</div>
          </div>
          <div class="action-points-wrapper">
            {#if isWIRusUser()}
              <div class="action-points">{action.points}</div>
            {/if}
          </div>
        </div>
      {/each}
    </div>
    {:else}
      <HostDialog bind:host={host}></HostDialog>
    {/if}
  </div>

  <div id="dialog-container" />
</div>
